import { render, staticRenderFns } from "./ButtonContentPaginationNav.vue?vue&type=template&id=5fabece4"
import script from "./ButtonContentPaginationNav.vue?vue&type=script&lang=js"
export * from "./ButtonContentPaginationNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports